import { useMemo } from "react";

import { COST_TYPES } from "Signups/SharedComponents/costTypes";
import { useSignups } from "Signups/state";

import { getFundItAmountsInDollars } from "../../utils/fundItAmountsConversions";

const useCommonFundItPostData = () => {
  const [
    {
      currentSignupList: {
        fundIt: { fund, isSuggestedDonation } = {},
        ID,
        isPerSignupCostType,
      },
    },
  ] = useSignups();

  const commonFundItPostData = useMemo(() => {
    return {
      costType: isPerSignupCostType
        ? COST_TYPES.PER_SIGNUP
        : COST_TYPES.PER_SLOT,
      fundID: fund?.ID,
      hasSignupCost: true,
      isSuggestedDonation,
      signupListID: ID,
    };
  }, [
    ID,
    fund?.ID,
    isPerSignupCostType,
    isSuggestedDonation,
    // perSignupCostTypeAmount,
  ]);

  return commonFundItPostData;
};

const useAmounts = () => {
  const [
    {
      currentSignupList: {
        fundIt: { cost: { amounts: amountsState } = {} } = {},
      },
    },
  ] = useSignups();

  const amounts = useMemo(() => {
    // If we are sent a number, convert things to the correct data structure
    if (typeof amountsState === "number" || typeof amountsState === "string") {
      return [{ amount: amountsState, numberOfSlots: null, id: "max" }];
    }
    return amountsState || [];
  }, [amountsState]);

  return amounts;
};

const useAmountsInDollars = () => {
  const amounts = useAmounts();
  const amountsInDollars = useMemo(
    () => getFundItAmountsInDollars(amounts),
    [amounts]
  );

  return amountsInDollars;
};

export const fundItStateHooks = {
  useCommonFundItPostData,
  useAmounts,
  useAmountsInDollars,
};
